import React, { useState, useEffect } from "react";


import constants from "../../helpers/constants";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function HeaderComponent(props) {

  let menutItems = [];
  menutItems.push(...constants.MENU_ITEMS);

 
  useEffect(() => {
   
  }, []);

 
  const MenuItem = (x) => {
    return (
        <Nav.Link className="header-link" href={x.link}
        >
          {x.title}
        </Nav.Link>
    )
  };

  return (
    <>
     <Navbar className="grey header" variant="light">
     <Navbar.Brand  className="header-title" href="#">Online Api Document</Navbar.Brand>
        <Container>
         
          <Nav className="me-auto">
            {menutItems.map(x=> MenuItem(x)) }
          </Nav>
        </Container>
      </Navbar>
    </>
  );
}

export default HeaderComponent;
